import { render, staticRenderFns } from "./EmailCallPopup.vue?vue&type=template&id=12ac5630&"
import script from "./EmailCallPopup.vue?vue&type=script&lang=js&"
export * from "./EmailCallPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Jenkins_Home\\workspace\\liveinfo3-front-user-dev-002\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12ac5630')) {
      api.createRecord('12ac5630', component.options)
    } else {
      api.reload('12ac5630', component.options)
    }
    module.hot.accept("./EmailCallPopup.vue?vue&type=template&id=12ac5630&", function () {
      api.rerender('12ac5630', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/druginfo/EmailCallPopup.vue"
export default component.exports